export default __webpack_public_path__ + "static/media/logo-2.dcdd2b33.png";